import {Box, HBox} from '../../../../../../src/components/core/view';
import React, {useMemo} from 'react';
import {
  formatCurrency,
  getDefaultImageUrl,
} from '../../../../../../src/utils/common';
import {
  useColorThemeType,
  useFontTheme,
} from '../../../../../../src/appStyles/hooks/theme';

import {CustomImage} from '../../../../../../src/components/core/Image';
import {CustomText} from '../../../../../../src/components/core/text';
import {DriverItem} from '../../../../../../src/driver/types/orderDetails';
import {styles} from './styles';

interface ItemCellForDriverProps {
  itemInfo: DriverItem;
}

const ItemCellForDriver: React.FC<ItemCellForDriverProps> = props => {
  const theme = useColorThemeType('main');
  const muli = useFontTheme('muli');
  const itemInfo = props?.itemInfo;
  const imageUrl = itemInfo?.itemImageUrl || '';
  const itemName = itemInfo?.name || '';
  const itemPrice = itemInfo?.price || 0;
  const itemQuantity = itemInfo?.quantity || 0;
  const defaultImage = getDefaultImageUrl();

  const getText = useMemo(() => {
    if (
      itemInfo?.isNSC2Item &&
      itemInfo?.orderItemAttribute?.weight &&
      itemInfo?.orderItemAttribute?.units
    )
      return `Wgt: ${itemInfo?.orderItemAttribute?.weight
        ?.toFixed(2)
        .replace(/[.,]00$/, '')} ${itemInfo?.orderItemAttribute.units}`;
    return `Qty: ${itemQuantity}`;
  }, [
    itemInfo?.isNSC2Item,
    itemInfo?.orderItemAttribute?.units,
    itemInfo?.orderItemAttribute?.weight,
    itemQuantity,
  ]);

  return (
    <HBox style={styles.parentBox}>
      <Box style={styles.imageBox}>
        <CustomImage
          onErrorSource={defaultImage}
          style={styles.image}
          source={imageUrl || defaultImage}
        />
        <HBox
          style={[
            styles.qtyBox,
            {
              backgroundColor: theme?.background?.yellow?.[100],
            },
          ]}>
          <CustomText
            style={{
              color: theme?.text?.blue?.[300],
              fontFamily: muli?.[700]?.normal,
            }}>
            {getText}
          </CustomText>
        </HBox>
      </Box>
      <Box style={styles.textBox}>
        <HBox>
          <Box style={styles.namePriceBox}>
            <CustomText
              numberOfLines={1}
              alignText="left"
              style={{
                color: theme?.text?.blue?.[300],
                fontFamily: muli?.[700]?.normal,
              }}>
              {itemName}
            </CustomText>
            <CustomText
              alignText="left"
              style={[
                styles.priceText,
                {
                  color: theme?.text?.blue?.[300],
                  fontFamily: muli?.[700]?.normal,
                },
              ]}>
              {formatCurrency(itemPrice)}
            </CustomText>
          </Box>
        </HBox>
      </Box>
    </HBox>
  );
};

export default React.memo(ItemCellForDriver);
